<template>
  <div class="bc-report-hint-dialog">
    <el-dialog
      :visible="animationShow"
      :modal-append-to-body="false"
      @close="close"
    >
      <pagination-table
        :title="source.title"
        :show-empty="true"
        :table-data="source.entities"
        :table-props="source.props"
        :total="source.total"
        :loading="source.loading"
        :page-index="source.pageIndex"
        :page-size="source.pageSize"
        @pageChanged="hintTablePageChanged"
      />
    </el-dialog>
  </div>
</template>

<script>
import PaginationTable from '@/components/table/PaginationTable'
import lawExamProps from '@/service/law-exam/props'
import mixin from '@/mixins/lawExamReport'
import lawExamService from '@/service/law-exam'
import lawExamParseFunc from '@/service/law-exam/parseFunc'
export default {
  name: 'BcReportHintDialog',
  components: { PaginationTable },
  mixins: [ mixin ],
  props: {
    prop: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      animationShow: false,
      source: {
        total: 0,
        pageIndex: 1,
        pageSize: 10,
        entities: [],
        loading: false
      }
    }
  },
  computed: {
    companyParams () {
      return this.$route.query
    },
    table () {
      return {
        key: this.prop,
        source: this.source
      }
    }
  },
  mounted () {
    this.animationShow = true
    let obj = lawExamProps[this.prop]
    Object.keys(obj).forEach(key => {
      this.$set(this.source, key, obj[key])
    })
    this.fetchData()
  },
  methods: {
    hintTablePageChanged (page) {
      if (this.prop === 'changeRecord') {
        this.requestChangeRecordInfo(page)
        return
      }
      this.tablePageChanged(page, this.table)
    },
    fetchData () {
      if (this.prop === 'changeRecord') {
        this.requestChangeRecordInfo(1)
        return
      }
      this.requestInfo(1, this.table)
    },
    requestChangeRecordInfo (page) {
      let source = this.source
      let path = this.prop
      source.loading = true
      let params = { companyId: this.companyId, pageNum: page, pageSize: source.pageSize }
      lawExamService.reportRequestBaseInfo(path, params).then(res => {
        this.parseData(path, res, source, page, lawExamParseFunc[path])
      }).catch(_ => {
        source.loading = false
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus">
.bc-report-hint-dialog
  .el-dialog__header
    margin-bottom 0px
    padding-top 0px
    padding-bottom 1px
  .el-dialog__body
    padding-top 0px
</style>
